import React, { useCallback, useState } from 'react';
import { truncate } from 'lodash';

const ExpandableText = ({ text, limit }) => {
  const [collapsed, toggleCollapsed] = useState(true);
  const onToggleCollapsed = useCallback(() => {
    toggleCollapsed((value) => !value);
  }, []);
  const long = text.length > limit;
  const textToRender = long && collapsed ? truncate(text, { length: limit }) : text;

  return (
    <div
      style={{
        ...(long && {
          cursor: 'pointer',
        }),
        ...(collapsed && {
          whiteSpace: 'nowrap',
        }),
        wordBreak: 'break-all',
      }}
      onClick={onToggleCollapsed}
      onKeyDown={() => {}}
    >
      {textToRender.split('\n').map((item, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={key}>
          {item}
          <br />
        </span>
      ))}
    </div>
  );
};

export default ExpandableText;
